export default "__VITE_ASSET__DUrHsqRa__"